import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Custom hook to force scroll to top on route change
 * This ensures pages always start from the top
 */
export const useScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    // Force immediate scroll to top using multiple methods
    const scrollToTop = () => {
      // Method 1: Standard window scroll
      window.scrollTo(0, 0);
      
      // Method 2: Document element
      if (document.documentElement) {
        document.documentElement.scrollTop = 0;
      }
      
      // Method 3: Body element
      if (document.body) {
        document.body.scrollTop = 0;
      }
      
      // Method 4: Force with requestAnimationFrame for better reliability
      requestAnimationFrame(() => {
        window.scrollTo(0, 0);
      });
    };

    // Execute immediately
    scrollToTop();
    
    // Also execute after a small delay to catch any late-loading content
    const timeoutId = setTimeout(scrollToTop, 0);
    
    return () => clearTimeout(timeoutId);
  }, [location.pathname, location.search]);
};

export default useScrollToTop;